/**
 * OrganizationJsonLd — entity-cluster schema for Google
 * ------------------------------------------------------
 * Tells search engines that:
 *   • TurfPulse is operated by Hi Tex Lawn Pro LLC
 *   • afincalc.com is a sister product under the same legal entity
 * This is the machine-readable companion to the visual HiTexProductsFooter.
 *
 * Mount once on the HomePage. Google reads it across the site once cached.
 *
 * Schema reference: https://schema.org/Organization
 */
import { Helmet } from 'react-helmet-async';

const ORG = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'TurfPulse',
  legalName: 'Hi Tex Lawn Pro LLC',
  url: 'https://getturfpulse.com',
  logo: 'https://getturfpulse.com/og-image.png',
  description:
    'TurfPulse is a smart lawn-care platform built on Growing Degree Days (GDD), real-time soil moisture, and FAO-56 evapotranspiration math — so homeowners and lawn enthusiasts know exactly when to spray, water, and feed.',
  foundingDate: '2025',
  parentOrganization: {
    '@type': 'Organization',
    name: 'Hi Tex Lawn Pro LLC',
    url: 'https://getturfpulse.com',
  },
  sameAs: [
    'https://afincalc.com',
    'https://www.facebook.com/TurfPulse',
  ],
  contactPoint: [
    {
      '@type': 'ContactPoint',
      contactType: 'customer support',
      email: 'hello@getturfpulse.com',
      availableLanguage: ['English'],
    },
  ],
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Round Rock',
    addressRegion: 'TX',
    addressCountry: 'US',
  },
};

export const OrganizationJsonLd = () => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(ORG)}</script>
  </Helmet>
);

export default OrganizationJsonLd;
